<template>
  <div class="main">
    <div class="bg">
      <img src="@/assets/images/diaocha.svg" style="width: 100%;height: 96%;">
    </div>
    <div class="words">
      <div style="width: 92%;">
        <p>尊敬的先生/女士：</p>
        <p style="text-indent: 5rem;">您好，感谢您接受了我们的体检服务，我们的成长非常需要您的支持和鼓励。</p>
        <p v-if="answers.length<=0" style="text-indent: 5rem;">
          请您填写下面的问卷，我们将您的意见妥善处理并进行保密，有了您的建议，我们才能继续改进。再次感谢您的合作</p>
      </div>
    </div>
    <div class="content">
      <div style="width: 96%;background: #fff;border-radius: 1rem;margin-top: 1rem;margin-bottom: 5rem;">
        <van-form v-if="answers.length<=0" style="padding: 2rem;">
          <div v-for="item in questions.filter(item=>item.optiontype == '1')"
               v-bind:key="item.questionid">
            <div style="padding: 1rem;">
              <div style="font-size: 3rem;">
                <div style="width: 1rem;height: 2.5rem;background: linear-gradient(to bottom right,#10E3E9,#5091F9);
                          display: inline-block;border-radius: 2px;margin-right: 1rem;"></div>
                {{ item.title }}（单选）
              </div>
            </div>
            <van-radio-group v-model="item.index">
              <van-cell-group v-for="jtem in item.questionsOptions" v-bind:key="jtem.optionsid">
                <van-cell :title="jtem.title">
                  <template #right-icon>
                    <van-radio :name="jtem.optionsid" @click="radioChange(item.questionid,jtem.optionsid)"/>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
          <div v-for="item in questions.filter(item=>item.optiontype == '2')"
               v-bind:key="item.questionid">
            <div style="padding: 1rem;">
              <div style="font-size: 3rem;">
                <div style="width: 1rem;height: 2.5rem;background: linear-gradient(to bottom right,#10E3E9,#5091F9);
                          display: inline-block;border-radius: 2px;margin-right: 1rem;"></div>
                {{ item.title }}（多选）
              </div>
            </div>
            <van-checkbox-group v-model="checkboxResult">
              <van-cell-group v-for="jtem in item.questionsOptions" v-bind:key="jtem.optionsid">
                <van-cell :title="jtem.title">
                  <template #right-icon>
                    <van-checkbox :name="jtem.optionsid" ref="checkboxes"
                                  @click="checkboxChange(item.questionid,jtem.optionsid)"/>
                  </template>
                </van-cell>
              </van-cell-group>
            </van-checkbox-group>
          </div>
          <div v-for="(item,index) in questions.filter(item=>item.optiontype == '3')"
               v-bind:key="index">
            <div style="padding: 1rem;">
              <div style="font-size: 3rem;">
                <div style="width: 1rem;height: 2.5rem;background: linear-gradient(to bottom right,#10E3E9,#5091F9);
                          display: inline-block;border-radius: 2px;margin-right: 1rem;"></div>
                {{ item.title }}
              </div>
            </div>
            <van-field
                name="textarea"
                v-model="message[index]"
                rows="3"
                autosize
                type="textarea"
                maxlength="200"
                placeholder="请填写..."
                show-word-limit
            />
          </div>
          <div v-if="answers.length <= 0" style="width: 100%;margin-top: 5rem;">
            <van-button round block native-type="button"
                        :disabled="submitBtnDisabled"
                        @click="submit"
                        color="linear-gradient(to right, #10E3E9, #409EFF)"
                        style="margin-top: 1em;margin-bottom: 2rem;" type="info"> 确 认 提 交
            </van-button>
          </div>
        </van-form>
        <div v-if="answers.length > 0" class="dialog-text-box">
          <div v-for="(item,index) in answers" :key="index" style="margin-bottom: 25px">
            <div class="text-item">
              <template>
                <div class="chat-name">问</div>
                <div class="chat-box">{{ item.qtitle }}</div>
              </template>
            </div>
            <div class="text-item text-item-right">
              <template>
                <div class="chat-box">{{ item.otitle }}</div>
                <div class="chat-name">答</div>
              </template>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import {
  selectQuestionsAndOptions,
  addQuestionnaireAnswer,
  getLt30DayMedicalRecord,
  getQuestionnaireTypeID,
  getLt30DayMedicalSerialno, getUserInfoByPatientid, getUserInfoByCarId
} from '@/api/module/index'
import {Dialog, Toast} from "vant";
import {GetAge} from '@/assets/utils/utils'
import {encrypt} from "@/assets/utils/cryptoUtil";

export default {
  name: "index",
  data() {
    return {
      user: undefined,
      name: '',
      radio: '',
      message: new Array(),
      questions: [],//调查问卷列表
      checkboxResult: [],
      checkRadioMap: new Map(),//选择的单选题目答案
      checkBoxMap: new Map(),//选择的多选题答案
      answers: [],
      typeid: "",
      serialno: "",
      submitBtnDisabled: false // 按钮置灰
    }
  },
  created() {
    this.name = window.g.VUE_APP_HOSPITALNAME
    this.serialno = this.$route.query.serialNo

    this.user = JSON.parse(localStorage.getItem("loginuser"))
    if (!this.user) {
      this.user = JSON.parse(localStorage.getItem("GuideUser"))
    }
    this.getQuestionnaireTypeID()

    // 如果有流水号则不查询
    if (this.serialno) {
      this.getList()
    } else {
      if (!this.user) {
        this.getUserInfoByCarIdNamePhone()
      } else {
        this.getLt30DayMedicalSerialno()
        this.getLt30DayMedicalRecord()
      }
    }
  },
  methods: {
    getUserInfoByCarIdNamePhone() {
      let params = {
        carId: encrypt(this.$route.query.carId),
        name: encrypt(this.$route.query.name),
        phone: encrypt(this.$route.query.phone)
      }
      getUserInfoByCarId(params).then(res => {
        //2025-07-03 luotong 处理PatientID加密出错导致的出错
        if(res.data == -1 && res.msg === "参数patientid错误"){
          Dialog({
            message: "登录过期，返回重新登录",
            theme: 'round-button',
          }).then(() => {
            window.localStorage.removeItem("loginuser")
            localStorage.removeItem("token")
            this.$router.push({name: 'login'})
          });
        }
        this.user = res.data
        this.getLt30DayMedicalSerialno()
        this.getLt30DayMedicalRecord()
      })
    },
    getQuestionnaireTypeID() {
      let params = {
        typename: "满意度调查问卷"
      }
      getQuestionnaireTypeID(params).then(res => {
        if (res.code == 200) {
          this.typeid = res.data
          console.log(this.typeid)
        }
      })
    },
    getLt30DayMedicalSerialno() {
      let params = {
        patientid: this.user.patientid
      }
      getLt30DayMedicalSerialno(params).then(res => {
        if (res.code == 200) {
          if (res.data != -1) {
            this.serialno = res.data
            console.log(this.serialno)
          }
        }
      })
    },
    getLt30DayMedicalRecord() {
      let params = {
        patientid: this.user.patientid
      }
      getLt30DayMedicalRecord(params).then(res => {
        if (res.code == 200) {
          if (res.data == -1) {
            //答题时间超期，该问卷只能在体检后的一个月时间答题

          } else {
            if (res.data.length > 0) {
              //显示答案
              this.answers = res.data
            } else {
              this.getList()
            }
          }
        }
      })
    },
    getList() {
      if (this.user.name == undefined) {
        Dialog.alert({
          title: '提示',
          message: '请您完善个人资料！',
        }).then(() => {
          this.$router.push({name: 'userinfo'})
        })
        return
      }
      let params = {
        typename: '满意度调查问卷'
      }
      selectQuestionsAndOptions(params).then(res => {
        if (res.code == 200) {
          this.questions = res.data
        }
      })
    },
    //单选框点击
    radioChange(questionid, optionsid) {
      this.checkRadioMap.set(questionid, optionsid)
    },
    //多选框点击
    checkboxChange(questionid, optionsid) {
      if (this.checkBoxMap.has(questionid)) {
        //多选题，如果有选择过答案
        let str = this.checkBoxMap.get(questionid)
        if (str.includes(optionsid)) {
          //如果已经选择了，则取消
          let arr = new Array()
          arr = str.split("|")
          arr = arr.filter(item => {
            return item !== optionsid
          })
          this.checkBoxMap.set(questionid, arr.join("|"))
        } else {
          //如果没有选择，则添加
          if (this.checkBoxMap.get(questionid) == "") {
            this.checkBoxMap.set(questionid, optionsid)
          } else {
            this.checkBoxMap.set(questionid, str + "|" + optionsid)
          }
        }
      } else {
        this.checkBoxMap.set(questionid, optionsid)
      }
    },
    //满意度调查问卷提交
    submit() {
      let strArr = new Array();//用来存放文本类型的答案
      let arr = document.getElementsByName("textarea");
      arr.forEach(item => {
        if (item.value != '') {
          strArr.push(item.value)
        } else {
          strArr.push("")
        }
      })
      if (this.checkRadioMap.size == 0 && this.checkBoxMap.size == 0 && strArr.length == 0) {
        Dialog.confirm({
          title: '提示',
          message: '您还没有填写任何内容，是否继续填写？点击确认继续答卷，点击取消返回上个页面',
        }).then(() => {
          // on confirm
        }).catch(() => {
          // this.$router.push({name: 'userinfo'})
          this.$router.back()
        });
        return
      } else {

        // 防重复点击
        this.submitBtnDisabled = true;

        let param = {
          name: this.user.name,
          phone: this.user.phone,
          cardid: this.user.cardid,
          age: GetAge(this.user.cardid),
          patientID: this.user.patientid,
          physicalNo: this.user.physicalno,
          serialNo: this.serialno,
          sexID: this.user.sexid,
          birthDate: this.user.birthdate?.substring(0, 10) || '',
          marital: this.user.marital,
          typeID: this.typeid
        }
        //问题的字符串集合
        //答案的字符串集合
        let questionnaireAnswerList = new Array()
        this.checkRadioMap.forEach((value, key) => {
          if (value != '') {
            let answer = {
              questionid: key,
              result: value
            }
            questionnaireAnswerList.push(answer)
          }
        })
        this.checkBoxMap.forEach((value, key) => {
          if (value != '') {
            let answer = {
              questionid: key,
              result: value
            }
            questionnaireAnswerList.push(answer)
          }
        })
        param.questionnaireAnswerList = questionnaireAnswerList
        //文本填写答案
        param.answerstr = strArr.join(",")
        param.questionidstr = this.questions.filter(item => item.optiontype == '3').map(item => item.questionid).join(",")
        addQuestionnaireAnswer(param).then(res => {
          if (res.code == 200) {
            Toast.success(res.msg);
            if (localStorage.getItem("loginuser")) {
              // this.$router.push({name: 'userinfo'})
              // this.$router.back()
              // 重新获取问卷信息 展示已答题目
              this.getLt30DayMedicalRecord()
            } else {
              this.getLt30DayMedicalRecord()
            }
          }
        })
         .finally(() => {
           // 解除 按钮 点击状态
           //  this.submitBtnDisabled = false;
         })
      }
    },
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  background-image: linear-gradient(to bottom right, #10E3E9, #5091F9, #10E3E9);
}

.bg {
  width: 100%;
  height: 30rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.words {
  width: 100%;
  color: #fff;
  font-weight: 500;
  font-size: 2.5rem;
  display: flex;
  justify-content: center;
}

.content {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-top: 2rem;
}

/*题目和答案*/
.dialog-text-box {
  background-color: #F2F2F2;
  padding: 30px 15px;
  margin-top: 70px;
  margin-bottom: 70px;
}

.dialog-text-box::-webkit-scrollbar {
  display: none;
}

.text-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 2em;
}

/*.text-item:last-child {*/
/*  margin-bottom: 0;*/
/*}*/
.chat-name {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 50%;
  background-color: #3C8AFF;
  color: #Ffffff;
}

.chat-box {
  margin-left: 15px;
  padding: 8px;
  max-width: calc(100% - 55px);
  background: #FFFFFF;
  border: 3px #000 solid;
  position: relative;
  border-radius: 10px;
  box-shadow: 2px 5px 0px rgba(25, 137, 250, .7);
}

.chat-box:before, .chat-box:after {
  content: "";
  position: absolute;
  right: 101%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 15px;
  border-color: transparent #000000 transparent transparent;
  transform: translateY(-50%);
}

.chat-box:before {
  top: 52%;
}

.chat-box:after {
  border-width: 2px 15px;
  border-right-color: #ffffff;
  top: 50%;
}

.text-item-right {
  justify-content: flex-end;
  margin-bottom: 15px;
  margin-left: 0;
}

.text-item-right .chat-name {
  background-color: #07c160;
}

.text-item-right .chat-box {
  margin-left: 0;
  margin-right: 15px;
}

.text-item-right .chat-box:before {
  right: -15px;
  border-width: 5px 15px;
  border-left-color: #000000;
  border-right: none;
}

.text-item-right .chat-box:after {
  right: -15px;
  border-width: 2px 15px;
  border-left-color: #ffffff;
  border-right: none;
}
</style>
